import React from 'react';
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import renderIf from 'render-if';// to use conditional rendering based on values that is provided to component
import { Link } from 'react-router-dom'; //  to change path from inside or to alter react-router-dom path
import User from 'components/User';
import UserNavbar from 'components/Navbar';
import ActionableItems from 'components/HeaderActionableItems';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import styles from './Header.scss';// to import local scss fle

const ProfileHeader = (props) => {
  const renderAthlete = renderIf(!props.coachProfile);
  const renderActionItems = renderIf(props.actionItems);
  const headerOnDashboard = false;
  return (
    <div
      className={props.coachProfile === true ? cn('row', styles.headerContainerCoach) : cn('row', styles.headerContainer)}
    >
      <div className={cn('col s12', styles.navBar)}>
        <UserNavbar {...props} headerOnDashboard={headerOnDashboard} usedFor="profile_page" />
      </div>

      <div className={cn('col s12', styles.profileDetails)}>
        <div className={cn('col s12 m7', styles.userContainer)}>
          {props.page === 'coachAthleteView' ?
                ''
                :
                <Link to="/settings">
                  <button className={styles.editIcon} >
                    <img src="https://media.dev.myrecruitboard.com/Images/editIconProfile.png" alt="edit_icon" />
                  </button>
                </Link>
            }
          {renderAthlete(
            <User {...props} />,
            )}
        </div>
        <div className={cn('col s12 m5', styles.buttonContainer)}>
          <span>
            <div className={styles.textAlignCenter}>
              {renderActionItems(
                <ActionableItems {...props} />,
            )}
            </div>
            {props.page === 'coachAthleteView' ?
              ''
                :
              <div>
                <Link to="/settings">
                  <button>EDIT PROFILE</button>
                </Link>
              </div>
            }

          </span>
        </div>
      </div>
    </div>
  );
};

ProfileHeader.propTypes = {
  coachProfile: PropTypes.isRequired,
  page: PropTypes.string.isRequired,
  // description: PropTypes.string.isRequired,
  actionItems: PropTypes.bool,
};

ProfileHeader.defaultProps = {
  actionItems: false,
};

export default ProfileHeader;



// WEBPACK FOOTER //
// ./src/components/ProfileHeader/Header.js